import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessage";

import { addPrescription } from "services/prescription-management";
import { Link, useNavigate } from "react-router-dom";

const AddPrescription = ({
  addPrescriptionInstance,
  selectedPrescriptionDetail,
  closeModel,
}) => {
  // console.log("selectedPrescriptionDetail:---->", selectedPrescriptionDetail);
  const navigate = useNavigate();

  const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");

  const addPrescriptionHandler = async () => {
    try {
      setBannerButtonLoader(true);
      const {
        data: { code, status, message },
      } = await addPrescription({
        id: selectedPrescriptionDetail._id,
        status: "APPROVED",
      });
      if (status || code === 200) {
        closeModel();
        toastMessage(message, "success", "DeleteCategory");
        navigate("/prescription-management");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setBannerButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={addPrescriptionInstance}
        handleClose={closeModel}
        content="Are you sure you want to Add this Prescription?"
        title="Add Prescription"
        buttonLoader={bannerButtonLoader}
        action={addPrescriptionHandler}
      />
    </>
  );
};

export default AddPrescription;
